import {
  Home,
  CalendarDays,
  Users,
  Building2,
  Clapperboard,
  SlidersHorizontal,
  ListCheck,
  ListMusic,
  Video,
  ChartNoAxesColumn,
  UserPen
} from "lucide-react";
import {
  SidebarProvider,
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarFooter,
  SidebarTrigger,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenuItem
} from "@/components/ui/sidebar"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import { useTranslate } from "@/helper/translate" ;

export function RmSidebar() {
const navigate = useNavigate();
const { linkedCustomerId } = useAuth();
const { translate } = useTranslate();

const sidebarItems = [

   {
    title: translate("ui.events"),
    url: "events",
    icon: ListCheck,
  },
  {
    title: translate("ui.calendar"),
    url: "/calendar",
    icon: CalendarDays,
  },

  // {
  //   title: "Sites",
  //   url: "/sites",
  //   icon: Building2,
  // },
  {
    title: translate("ui.urlshortener"),
    url: "shortener",
    icon: Video,
  }
]


  return (
    <SidebarProvider>
      {/* TODO: Herausfinden woher --header-height kommt? */}
      {/* <Sidebar  className="top-[--header-height] !h-[calc(100svh-var(--header-height))]"> */}
      <Sidebar className="top-[60px] !h-[calc(100svh-60px)]">

        {/* <SidebarHeader>
           <div className="flex gap-1">
            <div>
              <Avatar>
                <AvatarImage src="https://github.com/shadcn.png" />
                <AvatarFallback>CN</AvatarFallback>
              </Avatar>
            </div>
            <div className="text-sm">
              <p className="font-bold">Sally Saler</p>
              <p className="text-gray-500">Administrator</p>
            </div>
          </div> 
        </SidebarHeader> */}

        {/* <Separator /> */}


        <SidebarContent>

          <SidebarGroup>
            <SidebarGroupLabel>Menu</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {sidebarItems.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild onClick={() => navigate(item.url)} >
                      <div className="cursor-pointer">
                        <item.icon />
                        <span>{item.title}</span>
                      </div>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>

        </SidebarContent>

        <SidebarFooter />
      </Sidebar>
      {/* <SidebarTrigger /> */}
    </SidebarProvider>
  )
}